<template>
  <div>
    <el-input
      v-model="localValue"
      :min="min"
      :max="max"
      :class="`required-value-${id}`"
      @change="validate"
      type="number"
      class="shadow-sm"
    />
    <p v-show="showError" class="mt-2 text-muted text-danger">
      {{ messageError }}
    </p>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import mixinVModel from 'src/util/mixinVModel';

export default {
  name: 'NumericCapture',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 1000,
    },
  },
  mixins: [mixinVModel],
  methods: {
    validate() {
      if (
        (this.required === 1 && !this.localValue) ||
        (this.localValue &&
          (this.localValue < this.min || this.localValue > this.max))
      ) {
        this.messageError = !this.localValue
          ? i18n.t('common_words.required_field')
          : `${i18n.t('common_words.value_between')} [${this.min} - ${
              this.max
            }]`;
        this.highlightItem(`required-value-${this.id}`);
        this.showMessageErrorLabel();

        return false;
      }

      return true;
    },
  },
};
</script>
